import React, { useEffect, useRef, useState } from "react";

declare global {
  interface Window {
    echarts: any;
  }
}

interface Props {
  data: any;
  charTitle: string;
  seriesTitle: string;
  seriesColor: string;
}

const BarChart = (props: Props) => {
  const chartRef = useRef(null);
  const [values, setValues] = useState<number[]>([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);

  useEffect(() => {
    setValues(props.data);
    if (window?.echarts && chartRef.current) {
      const myChart = window.echarts?.init(chartRef.current);

      // Meses del año
      const meses = [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ];

      console.log("values", values);
      console.log("props.data", props);

      const eventosporMes = Object.values(props.data);
      // Número de eventos por mes (ejemplo)

      // Configuración del gráfico
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: meses,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: props.charTitle || "Número de Eventos",
          },
        ],
        series: [
          {
            name: props.seriesTitle || "Eventos",
            type: "bar",
            barWidth: "60%",
            data: eventosporMes,
            itemStyle: {
              color: props.seriesColor || "#ff4d4f", // Color azul para las barras
            },
          },
        ],
      };

      myChart.setOption(option);
      // Establecer la opción de configuración

      // Manejar redimensionamiento responsive
      const handleResize = () => {
        myChart.resize();
      };

      window.addEventListener("resize", handleResize);

      // Limpieza: destruir el gráfico al desmontar el componente
      return () => {
        window.removeEventListener("resize", handleResize);
        myChart.dispose();
      };
    }
  }, []);

  return <div ref={chartRef} style={{ width: "100%", height: "400px" }} />;
};

export default BarChart;
